import React, { useEffect, useState } from "react";
import { TextField, Grid, Paper, CircularProgress, Typography, Box } from "@mui/material";
import MultipleSelectPlaceholder from "./MultipleSelectPlaceholder";
import { toast } from "react-toastify";

export default function ProductSelection({ selectedProducts, setSelectedProducts, existingSubscribeProduct }) {
  const [products, setProducts] = useState([]);
  const [eventNameFilter, setEventNameFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const loadProducts = async () => {
        setLoading(true);
        try {
          const res = await fetch(`/api/v1/select-product-list?page=${page}&event_name=${eventNameFilter}`);
          const data = await res.json();
          if (data.success) {
            setProducts((prev) => (page === 1 ? data.data : [...prev, ...data.data]));
          }
        } catch (error) {
          toast.error("Failed to load products");
        } finally {
          setLoading(false);
        }
      };

      setPage(1);
      loadProducts();
    }, 500); // debounce

    return () => clearTimeout(delayDebounce);
  }, [eventNameFilter, page]); // include `page` since it's used inside

  return (
    <Paper
      elevation={4}
      sx={{
        p: 4,
        maxWidth: 500,
        mx: "auto",
        mt: 5,
        borderRadius: 3,
        boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          mb: 3,
          color: "#333",
        }}
      >
        Select Products
      </Typography>

      <Grid container spacing={3}>
        {/* Event Name Filter */}
        <Grid item xs={12}>
          <TextField
            label="Filter by Event Name"
            variant="outlined"
            value={eventNameFilter}
            onChange={(e) => setEventNameFilter(e.target.value)}
            fullWidth
            sx={{
              backgroundColor: "#f9f9f9",
              borderRadius: 1,
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#ccc" },
                "&:hover fieldset": { borderColor: "#888" },
                "&.Mui-focused fieldset": { borderColor: "#1976d2" },
              },
            }}
          />
        </Grid>

        {/* Multi-select Product List */}
        <Grid item xs={12}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            <MultipleSelectPlaceholder
              products={products}
              selectedProducts={selectedProducts}
              onChange={setSelectedProducts}
              existingSubscribeProduct={existingSubscribeProduct}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}
